import { render, staticRenderFns } from "./weeklyPayments.vue?vue&type=template&id=fd5c9b2a&scoped=true&"
import script from "./weeklyPayments.vue?vue&type=script&lang=js&"
export * from "./weeklyPayments.vue?vue&type=script&lang=js&"
import style0 from "./weeklyPayments.vue?vue&type=style&index=0&id=fd5c9b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5c9b2a",
  null
  
)

export default component.exports